import { GenericFieldValue, OperatorType, SimpleConditionDefinition } from '@msdk/definitions'

export function createSimpleCondition(id: string, column: string, operator: OperatorType, value?: GenericFieldValue) {
  const condition: SimpleConditionDefinition = {
    id,
    field: column,
    not: false,
    operator,
    value: value?.value as string,
    fieldValue: value,
  }

  return condition
}
